import "../styles/Hero.css";
import { useLanguage } from "../contexts/LanguageContext";

const Hero = () => {
    const { language } = useLanguage();

    const heroContent = {
        brand: {
            english: "Lorem Ipsum",
            tamil: "லோரெம் இப்சம்"
        },
        brandes: {
            english: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
            tamil: "லோரெம் இப்சம் என்பது அச்சிடுதல் மற்றும் தட்டச்சு அமைப்புத் துறையின் போலி உரை மட்டுமே. 1500களில் இருந்து, தெரியாத ஒரு அச்சுப்பொறி ஒரு தட்டச்சு மாதிரி புத்தகத்தை உருவாக்க அதைத் துடைத்ததிலிருந்து லோரெம் இப்சம் தொழில்துறையின் நிலையான போலி உரையாக இருந்து வருகிறது. இது ஐந்து நூற்றாண்டுகள் மட்டுமல்ல, மின்னணு தட்டச்சு அமைப்பிலும் பாய்ந்து, அடிப்படையில் மாறாமல் உள்ளது. இது 1960களில் லோரெம் இப்சம் பத்திகளைக் கொண்ட லெட்ராசெட் தாள்களின் வெளியீட்டிலும், சமீபத்தில் லோரெம் இப்சமின் பதிப்புகள் உட்பட ஆல்டஸ் பேஜ்மேக்கர் போன்ற டெஸ்க்டாப் வெளியீட்டு மென்பொருளிலும் பிரபலமடைந்தது."
        }
    }

    const heroCardContent = {
        card1: {
            english: "VOTERS",
            tamil: "வாக்காளர்"
        },
        card2: {
            english: "MEMEBERS",
            tamil: "உறுப்பினர்"
        },
        card3: {
            english: "MISSIONS",
            tamil: "பணிகள்"
        },
        carddes1: {
            english: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
            tamil: "லோரெம் இப்சம் என்பது அச்சிடுதல் மற்றும் தட்டச்சு அமைப்புத் துறையின் போலி உரை மட்டுமே. 1500களில் இருந்து, தெரியாத ஒரு அச்சுப்பொறி ஒரு தட்டச்சு மாதிரி புத்தகத்தை உருவாக்க அதைத் துடைத்ததிலிருந்து லோரெம் இப்சம் தொழில்துறையின் நிலையான போலி உரையாக இருந்து வருகிறது."
        },
        carddes2: {
            english: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
            tamil: "லோரெம் இப்சம் என்பது அச்சிடுதல் மற்றும் தட்டச்சு அமைப்புத் துறையின் போலி உரை மட்டுமே. 1500களில் இருந்து, தெரியாத ஒரு அச்சுப்பொறி ஒரு தட்டச்சு மாதிரி புத்தகத்தை உருவாக்க அதைத் துடைத்ததிலிருந்து லோரெம் இப்சம் தொழில்துறையின் நிலையான போலி உரையாக இருந்து வருகிறது."
        },
        carddes3: {
            english: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
            tamil: "லோரெம் இப்சம் என்பது அச்சிடுதல் மற்றும் தட்டச்சு அமைப்புத் துறையின் போலி உரை மட்டுமே. 1500களில் இருந்து, தெரியாத ஒரு அச்சுப்பொறி ஒரு தட்டச்சு மாதிரி புத்தகத்தை உருவாக்க அதைத் துடைத்ததிலிருந்து லோரெம் இப்சம் தொழில்துறையின் நிலையான போலி உரையாக இருந்து வருகிறது."
        }
    }

    return (
        <div id="hero" className="Appy">
            <section className="hero">
                <div className="hero-container">
                    <div className="hero-left">
                        <img src="/assets/tvkimages/heroimg1.png" className="heroimg1" alt="" />
                        <img src="/assets/tvkimages/heroimg2.png" className="heroimg2" alt="" />
                    </div>

                    <div className="hero-right">
                        <h1>{heroContent.brand[language]}</h1>
                        <p>{heroContent.brandes[language]}</p>
                    </div>
                </div>
            </section>
            <section className="hero1">
                <div className="herocards">
                    <div className="herocard1">
                        <img src="/assets/tvkimages/Vector.png" alt="" />
                        <h1>{heroCardContent.card1[language]}</h1>
                        <p>{heroCardContent.carddes1[language]}</p>
                    </div>
                    <div className="herocard1">
                        <img src="/assets/tvkimages/Group 1.png" alt="" />
                        <h1>{heroCardContent.card2[language]}</h1>
                        <p>{heroCardContent.carddes2[language]}</p>
                    </div>
                    <div className="herocard1">
                        <img src="/assets/tvkimages/1628441 1.png" alt="" />
                        <h1>{heroCardContent.card3[language]}</h1>
                        <p>{heroCardContent.carddes3[language]}</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Hero;